import { HallowAnalyticsEvent } from "@packages/analytics";
import { Link } from "@packages/framework";
import type { AssignmentSectionItem } from "@packages/sdk";
import { snakeCase } from "@packages/sdk";
import type { AssignmentProps, CSSColorStrict } from "@packages/ui";
import { AssignmentCompletedOverlay } from "@packages/ui";
import type { format } from "date-fns/format";

import type { BaseGetSectionItemProps } from "./Section.emotion";

type GetSectionItemAssignmentPropsProps = BaseGetSectionItemProps & {
  item: AssignmentSectionItem;
  format: typeof format;
};

export const getSectionItemAssignmentProps = ({
  item,
  t,
  analytics,
  section,
  itemTypeLinkSearchParams = {},
  page,
  screenName,
  format,
}: GetSectionItemAssignmentPropsProps): AssignmentProps => {
  const href = `/prayers/${item.reference.content.id}`; // FIXME

  return {
    imageProps: {
      src: item.reference.content.images,
      imageOverlay: item.reference.is_completed ? (
        <AssignmentCompletedOverlay
          size={section.type === "grid" ? "s" : "l"}
        />
      ) : null,
    },
    asChild: true,
    children: (
      <Link
        href={`${href}?${new URLSearchParams(itemTypeLinkSearchParams[item?.reference_type]).toString()}`}
        onPointerUp={() => {
          analytics?.track({
            event: HallowAnalyticsEvent.TappedSectionItem,
            properties: {
              // Refactor: This event should be logged for every Section Item (move event up DOM tree)
              page_id: page?.id ?? null,
              page_title: snakeCase(page?.title) ?? null,
              page_slug: page?.slug ?? null,
              screen_name: screenName ?? null,
              section_id: section?.id,
              section_item_id: item?.item_id ?? null,
              section_title: section?.title ?? null,
              section_type: section?.type ?? null,
              index: section?.items.indexOf(item) ?? null,
              item: item?.reference?.content?.title ?? null,
              item_type: item?.type ?? null,
              section_cohort_id: section?.cohorts?.map((c) => c.id) ?? null,
              section_cohort: section?.cohorts?.map((c) => c.name) ?? null,
            },
          });
        }}
      />
    ),
    classroomProps: {
      avatarProps: {
        imgSrc: item.reference.community.image_url,
        color: item.reference.community.color_hex as CSSColorStrict,
        size: "xs",
      },
      name: item.reference.community.name,
    },
    tags: [
      t("assignments_due_at", {
        "0": format(new Date(item.reference.due_at), "MMM dd"),
      }),
    ],
    title: item.reference.content.title,
    description: item.reference.content.label_desc,
    color: item.reference.content.images.color_hex as CSSColorStrict,
    item,
    section,
  };
};
